import { FC, memo, useMemo } from 'react';
import cx from 'classnames';
import { useAppSelector } from 'redux/hooks';
import { formatVisiblePrice } from 'utils/common.utils';

interface PriceBadgeProps {
  price: number;
  regularPrice?: number;
  reverse?: boolean;
}

const PriceBadge: FC<PriceBadgeProps> = ({ price, regularPrice, reverse = false }) => {
  const bagItems = useAppSelector((state) => state.bagEvent.bag);

  const hasDiscount = useMemo(
    () =>  regularPrice && price && price !== regularPrice,
    [price, regularPrice]
  );

  const formattedPrice = useMemo(() => {
    return {
      regular: formatVisiblePrice(regularPrice || 0, bagItems.currency),
      sale: formatVisiblePrice(price, bagItems.currency)
    };
  }, [bagItems.currency, price, regularPrice]);

  return (
    <>
      {hasDiscount && (
        <span className={`font-normal text-brand-grey450 line-through ${reverse ? 'order-2 mr-0':'mr-[6px]'}`}>
          {formattedPrice.regular}
        </span>
      )}
      <span
        className={cx({
          'text-brand-green font-medium': hasDiscount,
          'order-1': reverse,
          'mr-[12px]': hasDiscount && reverse
        })}>
        {formattedPrice.sale}
      </span>
    </>
  );
};

export default memo(PriceBadge);
